import { Activity } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { LANGS } from "../lib/i18n";
import { HistorySheet } from "./HistorySheet";

export const TopBar = ({ t, lang, setLang, onOpenItem }) => (
  <header className="absolute inset-x-0 top-0 z-20 flex items-center justify-between gap-2 px-3 py-4 sm:px-6">
    <div className="flex min-w-0 items-center gap-2 sm:gap-3">
      <div className="grid h-9 w-9 shrink-0 place-items-center rounded-2xl sm:h-10 sm:w-10 bg-teal-700 text-white"><Activity size={20} /></div>
      <div>
        <p className="font-display whitespace-nowrap text-lg font-bold leading-none sm:text-xl tracking-tight text-slate-900" data-testid="app-logo">Dr. Nova</p>
        <p className="mt-1 hidden text-xs text-slate-500 md:block" data-testid="free-badge">{t("free")}</p>
      </div>
    </div>
    <div className="flex shrink-0 items-center gap-1.5 sm:gap-2">
      <Select value={lang} onValueChange={setLang}>
        <SelectTrigger data-testid="language-select" className="h-10 w-[96px] rounded-full sm:w-[112px] border-slate-200 bg-white/90 text-sm"><SelectValue /></SelectTrigger>
        <SelectContent>{LANGS.map((l) => <SelectItem key={l.code} value={l.code} data-testid={`lang-option-${l.code}`}>{l.name}</SelectItem>)}</SelectContent>
      </Select>
      <HistorySheet t={t} onOpenItem={onOpenItem} />
    </div>
  </header>
);
